import React from "react";
import { AdSenseUnit, AD_SLOTS } from "./AdSenseUnit";

// Vertical side ad shown next to the PDF editor. Slot: "Banda Vert".
export const EditorSideAd = () => {
  return (
    <aside
      data-testid="editor-side-ad"
      className="sticky top-24 hidden w-[300px] shrink-0 xl:block"
    >
      <span className="mb-1 block text-center text-[10px] font-medium uppercase tracking-wider text-slate-400">
        Annuncio
      </span>
      <div className="min-h-[600px] overflow-hidden rounded-2xl border border-slate-200 bg-white p-2">
        <AdSenseUnit
          testId="editor-side-ad-unit"
          slot={AD_SLOTS.editorVertical}
          style={{ display: "inline-block", width: 300, height: 600 }}
        />
      </div>
    </aside>
  );
};
